import React, {useState, useEffect, useRef} from 'react'
import { faPlus, faTimesCircle, faEllipsisV, faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from 'react-router-dom';
import { genNextId, sortById } from '../../utils/globalUtils';

const EditorListItem = ({params}) => {

    const [showForm, setShowForm] = useState(false);
    const [formMode, setFormMode] = useState("insert");
    const [formId, setFormId] = useState(0);
    const [title, setTitle] = useState("");
    const [showDesc, setShowDesc] = useState(false);
    const [description, setDescription] = useState("");
    const [frmError, setFrmError] = useState("");

    const data = [...params.data];

    function updateShowDesc(){
        setFrmError("");
        if(!showDesc){
            setDescription("");
        }
        setShowDesc(!showDesc);
    }

    function newItem(){
        clearForm();
        setFormMode("insert");
        setShowForm(true);
    }

    const editItem = (id)=>{
        setFormMode("edit");
        setShowForm(true);

        const obj = data.find(x=>parseInt(x.Id) == parseInt(id));
        setFormId(obj.Id);
        setTitle(obj.Title);
        setShowDesc(obj.ShowDesc);
        setDescription(obj.Description);
    }

    function closeForm(){
        setShowForm(false);
    }

    function addItem(){

        setFrmError("");

        if(title == ""){
            setFrmError("Please enter item");
            return;
        }

        if(showDesc){
            if(description == ""){
                setFrmError("Please enter description or remove it");
                return;
            }
        }

        if(formMode == "insert"){
            const id = genNextId(data);
            const obj = {
                Id: id,
                Title: title,
                ShowDesc: showDesc,
                Description: description
            }
            data.push(obj);
        }
        else if(formMode == "edit"){
            const index = data.findIndex(x=>parseInt(x.Id) == parseInt(formId));
            data[index] = {
                Id: parseInt(formId),
                Title: title,
                ShowDesc: showDesc,
                Description: description
            };
        }

        params.setData(data);
        setShowForm(false);
    }

    const deleteItem = (id) => {
        const filteredItems = data.filter(x=>parseInt(x.Id) != parseInt(id));
        params.setData(filteredItems);
    }

    function clearForm(){
        setFormId(0);
        setTitle("");
        setShowDesc(false);
        setDescription("");
    }
    
    const styles = {
        form:{
            background: "#edf4f3",
            maxWidth: 360,
            padding: 10,
            borderRadius: 5,
            border: '1px solid #ccc',
            position: 'relative'
        },
        label:{
            color: "#aaa",
            fontSize: 14,
            fontWeight: 500
        },
        labelSm:{
            color: "#999",
            fontSize: 12,
            fontWeight: 500
        },
        input:{
            outline: 'none',
            boxShadow: 'none',
            transition: 'none',
        },
        areaInput:{
            height: 100,
            outline: 'none',
            boxShadow: 'none',
            transition: 'none',
        },
        addDescWrap:{
            color: '#2e425b',
            textDecoration: 'none',
            fontSize: 13
        },
        addDesc:{
            display: 'flex',
            paddingTop: 10,
            paddingLeft: 2,
            paddingRight: 2
        },
        showDescIcon:{
            justifyContent: 'flex-end',
            marginLeft: 'auto'
        },
        showFormBtn:{
            textDecoration: 'none'
        },
        head:{
            marginBottom: 20,
            paddingTop: 10,
            paddingBottom: 10,
            borderBottom: '1px solid #ccc'
        },
        title:{
            color: '#666',
            fontSize: 18,
            fontWaight: 600
        },
        showStepFormBtn: {
            textDecoration: 'none',
            fontSize: 16,
        },
        cancelBtn:{
            color: '#666',
            fontSize: 20,
            position: 'absolute',
            top: 10,
            right: 10
        },
        formInfo:{
            marginBottom:10,
            fontSize: 14
        },
        frmError:{
            color: '#990000',
            marginTop: 15,
            fontSize: 14
        },
        list:{

        },
        listItem:{
            marginBottom: 30,
            position: 'relative'
        },
        title: {
            marginBottom: 2,
            fontSize: 16,
            fontWaight: 600
        },
        desc: {
            fontSize: 13,
            fontWaight: 400
        },
        listFooter:{
            marginBottom:30
        },
        saveBtn:{
            width: 80
        },  
    }

    function actions(id){
        const styles = {
            container: {
                position: 'absolute',
                top: 5,
                right: 5,
                zIndex: 999
            },
            btn:{
                background: 'none',
                color: '#888',
                border: 'none',
                fontSize: 15,
                outline: 'none',
                boxShadow: 'none',
                transition: 'none',
            },
            option:{
                fontSize: 14,
            },
            optionRed:{
                color: '#ff6d6d',
                fontSize: 14,
            },
        }
    
        return(
            <div style={styles.container}>
                <div class="dropdown">
                    <button type="button" data-toggle="dropdown" style={styles.btn}>
                        <FontAwesomeIcon icon={faEllipsisV} />
                    </button>
                    <div class="dropdown-menu dropdown-menu-right">
                        <Link onClick={()=>{editItem(id)}} class="dropdown-item" style={styles.option}>Edit</Link>
                        <div className="dropdown-divider"></div>
                        <Link onClick={()=>{deleteItem(id)}} class="dropdown-item" style={styles.optionRed}>Delete</Link>
                    </div>
                </div>
            </div>
        )
    }

    const formDisplay = (
       <div style={styles.form}>
            <div style={styles.head}>
                <h4 style={styles.title}>Item Form</h4>
                <Link onClick={()=>closeForm()} style = {styles.cancelBtn}>
                    <FontAwesomeIcon icon={faTimesCircle} />
                </Link>
            </div>
            <div>
            <div className='form-group'>
                <input type="text" value={title} onChange={e => setTitle(e.target.value)} style={styles.input} className="form-control" placeholder="Enter item" />
            </div>

            <div className='form-group'>
                <Link onClick={()=>updateShowDesc()} style = {styles.addDescWrap}>
                    <div style = {styles.addDesc}>
                        <div>{showDesc? "Remove Description": "Include Description (optional)"}</div>
                        <div style={styles.showDescIcon}>
                            <FontAwesomeIcon icon={showDesc? faChevronUp: faChevronDown} />
                        </div>
                    </div>
                </Link>
            </div>

            {showDesc &&
                <div className='form-group'>
                    <textarea value={description} onChange={e => setDescription(e.target.value)} style={styles.areaInput} className="form-control" placeholder="Enter description"></textarea>
                </div>
            }

            {(frmError != "") && 
               <div style={styles.frmError} className='form-group'>{frmError}</div>
            }

            <hr />
            <div className='form-group'>
                <Link onClick={()=>addItem()} style={styles.saveBtn} className='btn btn-sm btn-info'>Save</Link>
            </div>
            </div>
       </div>
    )

    const listDisplay = (
        <div style={styles.list}>
            {data.map(itm => (
                <div style={styles.listItem}>
                    {actions(itm.Id)}
                    <h4 style={styles.title}>{itm.Title}</h4>
                    <div style={styles.desc}>{itm.Description}</div>
                    <hr />
                </div>
            ))}

            {!(data.length > 0) &&
                <div style={styles.formInfo}>Click on the add item link below to add an item</div>
            }

            <div style={styles.listFooter}>
                <Link onClick={()=>newItem()} style = {styles.showFormBtn}>
                    <FontAwesomeIcon icon={faPlus} />&nbsp; Add Item
                </Link>
            </div>
            
        </div>
    )

    return (
        <div>
            {showForm? formDisplay: listDisplay}
        </div>
    )
}

export default EditorListItem